import { ApplicationEnum, SupportedVersions } from "../types";
import { PlatformV1RequestService, PlatformV2RequestService, SeamlessRequestService, WalletRequestService } from "./index";
import { CookieStorage } from "../helpers";
const RequestServiceMapper = {
    [ApplicationEnum.Platform]: (apiVersion, anonymousApiUrl, ajaxService, siteID, OperatorAuthTokenId) => {
        if (!PlatformServiceMapper[apiVersion]) {
            throw `Not supported api version: ${apiVersion}`;
        }
        return PlatformServiceMapper[apiVersion](anonymousApiUrl, siteID, ajaxService);
    },
    [ApplicationEnum.Wallet]: (apiVersion, anonymousApiUrl, ajaxService, siteID, OperatorAuthTokenId, domainID) => new WalletRequestService(anonymousApiUrl, ajaxService, CookieStorage, domainID),
    [ApplicationEnum.Seamless]: (apiVersion, anonymousApiUrl, ajaxService, siteID, OperatorAuthTokenId) => new SeamlessRequestService(anonymousApiUrl, OperatorAuthTokenId, ajaxService, CookieStorage)
};
const PlatformServiceMapper = {
    [SupportedVersions.v1]: (anonymousApiUrl, siteID, ajaxService) => new PlatformV1RequestService(anonymousApiUrl, siteID, ajaxService),
    [SupportedVersions.v2]: (anonymousApiUrl, siteID, ajaxService) => new PlatformV2RequestService(anonymousApiUrl, siteID, ajaxService)
};
export function getRequestService(applicationType, apiVersion, anonymousApiUrl, siteID, OperatorAuthTokenId, ajaxService, domainID) {
    if (!RequestServiceMapper[applicationType]) {
        throw `Not supported application type: ${applicationType}`;
    }
    return RequestServiceMapper[applicationType](apiVersion.toLowerCase(), anonymousApiUrl, ajaxService, siteID, OperatorAuthTokenId, domainID);
}
//# sourceMappingURL=RequestServiceFactory.js.map